<template>
  <div class="ten-time-range">
    <ten-date-time
      key="start"
      :value="start"
      :format="format"
      :get-related-input="getRelatedInput"
      :disabled-hour="disabledHour"
      :disabled-min="disabledMin"
      :disabled-sec="disabledSec"
      :min-time="minTime"
      @change="onStartChangeHandler"
    />
    <ten-date-time
      key="end"
      :value="end"
      :format="format"
      :get-related-input="() => getRelatedInput(1)"
      :disabled-hour="disabledHour"
      :disabled-min="disabledMin"
      :disabled-sec="disabledSec"
      :min-time="isSameDay ? start : undefined"
      @change="onEndChangeHandler"
    />
  </div>
</template>

<script>
import Time from './time';
import { compareTime, cloneTime, isSame } from '../util';

export default {
  components: {
    TenDateTime: Time,
  },
  inheritAttrs: false,
  props: {
    value: Array,
    format: String,
    getRelatedInput: Function,
    disabledHour: Function,
    disabledMin: Function,
    disabledSec: Function,
    minTime: Date,
  },
  computed: {
    start() {
      return this.value[0] ? new Date(this.value[0]) : this.value[0];
    },
    end() {
      return this.value[1] ? new Date(this.value[1]) : this.value[1];
    },
    isSameDay() {
      return !this.start || !this.end || isSame(this.start, this.end);
    },
  },
  methods: {
    onEndChangeHandler(newValue) {
      this.$emit('change', [this.start || '', newValue]);
    },
    onStartChangeHandler(newValue) {
      if (this.end && compareTime(newValue, this.end) >= 0 && this.isSameDay) {
        this.$emit('change', [newValue, cloneTime(newValue, this.end)]);
      } else {
        this.$emit('change', [newValue, this.end || '']);
      }
    },
  },
};
</script>
